import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { BulkImportModel } from '../../../../types';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import { useBulkOpActions } from './hooks/use-bulk-op-actions';
import { Messages } from '../../../utils/message-constants';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface BulkOpsGridToolbarProps {
  toolsRoles: string[];
  setOpenDeleteBulkOperations: Dispatch<SetStateAction<boolean>>;
  selectedBulkOps: BulkImportModel[];
}

export default function BulkOpsGridToolbar({
  toolsRoles,
  setOpenDeleteBulkOperations,
  selectedBulkOps,
}: BulkOpsGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { hasBulkOpsPermission } = useBulkOpActions();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          disabled={!hasBulkOpsPermission(toolsRoles)}
          onClick={() => {
            navigate(
              `/${pagesConfig.bulkOps.link}/${pagesConfig.createBulkOps.link}`
            );
          }}
          label="Create Bulk Op"
          tooltipLabel={
            !hasBulkOpsPermission(toolsRoles)
              ? Messages.BulkOps.NoCreatePermission
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => {
              setOpenDeleteBulkOperations(true);
            }}
            disabled={
              selectedBulkOps.length === 0 || !hasBulkOpsPermission(toolsRoles)
            }
            tooltipLabel={
              !hasBulkOpsPermission(toolsRoles)
                ? Messages.BulkOps.NoDeletePermission
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({ queryKey: ['BulkOps'] });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="bulkOpsGridStates"
            module={ModuleList.modules.importExport.name}
            section={ModuleList.modules.importExport.sections.bulkOperations}
          />
        </>
      }
    />
  );
}
